import {
  updateResourceState,
  normalizeResourceState,
  createResourceReducer,
  RESOURCE,
  RECORD_FIELD,
  defaultResourceState
} from 'react-structure-admin';

import {
  HEALTHSERVICEPROVIDER,
  HEALTHSERVICEPROVIDER_AVAILABILITY_FETCH,
  HEALTHSERVICEPROVIDER_AVAILABILITY_FETCH_FINISHED,
  HEALTHSERVICEPROVIDER_GET_CURRENT_FINISHED,
  HEALTHSERVICEPROVIDER_CANCEL_CURRENT,
  HEALTHSERVICEPROVIDER_PUT_CURRENT,
  HEALTHSERVICEPROVIDER_PUT_CURRENT_FINISHED
} from './healthServiceProviderActions';

const healthServiceProviderReducer = createResourceReducer(
  HEALTHSERVICEPROVIDER,
  [],
  {
    [HEALTHSERVICEPROVIDER_AVAILABILITY_FETCH](state, action) {
      const newState = normalizeResourceState(state, action.resource);

      return updateResourceState(newState, action, RESOURCE, () => ({
        activities: { ...defaultResourceState, loading: true }
      }));
    },

    [HEALTHSERVICEPROVIDER_AVAILABILITY_FETCH_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, (resource) => ({
        activities: {
          [RECORD_FIELD]: action.payload.data.result,
          loading: false
        },
        notFound: false
      }));
    },

    [HEALTHSERVICEPROVIDER_GET_CURRENT_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        currentProfessional: action.payload.data.result,
        editingCurrentProfessional: true,
        visible: false
      }));
    },

    [HEALTHSERVICEPROVIDER_PUT_CURRENT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        currentProfessional: action.payload,
        loading: true
      }));
    },

    [HEALTHSERVICEPROVIDER_PUT_CURRENT_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        currentProfessional: null,
        editingCurrentProfessional: false,
        visible: false,
        loading: false
      }));
    },

    [HEALTHSERVICEPROVIDER_CANCEL_CURRENT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        currentProfessional: null,
        editingCurrentProfessional: false
      }));
    }
  },
  (state, action) => {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: false,
      saving: false
    }));
  }
);

export default healthServiceProviderReducer;
